import { Dialog } from 'primereact/dialog';
import { InputNumber } from 'primereact/inputnumber';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { getDetailFile } from 'apis/specializeReviews.api';
import { formatFileName } from 'utils/func';
import RichTextViewer from 'components/RichTextViewer';

export default function SpecializeDetail({
  visible,
  setVisible,
  councilMemberId,
  councilId,
  projectProposalId,
  handleDownloadReviewFile,
}) {
  // #region Data
  const { t } = useTranslation();

  const { data: reviewData } = useQuery(
    ['Reviews', councilMemberId, councilId, projectProposalId],
    ({ queryKey: [, _councilMemberId, _councilId, _projectProposalId] }) =>
      getDetailFile(_councilMemberId, _councilId, _projectProposalId),
    { enabled: !!councilMemberId && visible }
  );
  const review = useMemo(() => reviewData?.data, [reviewData]);
  // #endregion

  return (
    <Dialog
      header={t('council.review.detailUpload')}
      headerStyle={{ padding: '1.5rem' }}
      visible={visible}
      draggable={false}
      style={review?.reportFileUrl ? { width: '600px' } : { width: '400px' }}
      onHide={() => setVisible(false)}
    >
      {review?.reportFileUrl ? (
        <div className="grid">
          <div className="col-12">
            <div className="mb-2">{t('council.review.conclusion')}</div>
            <RichTextViewer
              style={{ height: '200px' }}
              value={review?.conclusion}
              showHeader={false}
              readOnly
            />
          </div>
          <div className="col-12 flex align-items-center">
            <span className="w-8rem">{t('council.view.score')}</span>
            <InputNumber
              value={review?.score}
              readOnly
              inputClassName="w-4rem text-center font-semibold"
            />
          </div>
          <div className="col-12 flex align-items-center">
            <span className="w-7rem">{t('council.review.specializeAssessmentForm')}</span>
            {review?.reportFileUrl && (
              <span
                onClick={() =>
                  handleDownloadReviewFile(
                    councilMemberId,
                    projectProposalId,
                    councilId,
                    review?.reportFileUrl
                  )
                }
                className="p-button-text p-button"
              >
                <i className="pi pi-file-pdf text-red-500 text-xl" />
                <span className="text-blue-500 underline font-italic text-base">
                  {formatFileName(review?.reportFileUrl)}
                </span>
              </span>
            )}
          </div>
        </div>
      ) : (
        <span className="font-italic">{t('council.review.noReviewOrNotUpload')}</span>
      )}
    </Dialog>
  );
}

SpecializeDetail.propTypes = {
  councilMemberId: PropTypes.string.isRequired,
  councilId: PropTypes.string.isRequired,
  projectProposalId: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  handleDownloadReviewFile: PropTypes.func.isRequired,
};
